(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bizedeals-ebay-loader"] && !Shopify.designMode) return;
  try {
    (() => {
 const start = () => document.querySelectorAll('[data-ebay-related]').forEach(root => {
  if(root.dataset.ebayInitialized) return;
  root.dataset.ebayInitialized='true';
  const rail=root.querySelector('.bd-ebay-related__rail'), status=root.querySelector('[role="status"]'), retry=root.querySelector('[data-ebay-retry]');
  let nearby=false, current=null, timer, generation=0;
  const allowed=()=>Boolean(window.Shopify?.customerPrivacy?.marketingAllowed());
  const clear=()=>{generation++;clearTimeout(timer);current=null;rail.replaceChildren();rail.hidden=true;};
  const fail=ticket=>{if(ticket!==generation)return;clear();status.textContent='Listings are taking longer than expected. Browse directly on eBay or try again.';retry.hidden=!allowed();};
  const load=()=>{
   if(!allowed()){clear();status.textContent='Live eBay listings use marketing cookies. You can also browse related items directly on eBay.';retry.hidden=true;return;}
   if(!nearby||current)return;
   const ticket=++generation;
   retry.hidden=true;status.textContent='Loading related eBay listings…';
   const url=new URL('https://epnt.ebay.com/placement');
   Object.entries({st:'ACTIVE',cpid:'5339219059',l:'900x220',ft:'Open Sans, sans-serif;',tc:'#F7B100',clp:'true',mi:'10',k:root.dataset.ebayQuery,ctids:'0',mkpid:'EBAY-US',ur:'false',cts:'false',sf:'false',pid:Date.now()+'-'+ticket,ad_v:'2'}).forEach(([k,v])=>url.searchParams.set(k,v));
   const wrap=document.createElement('div');wrap.className='epn-placement';
   const frame=document.createElement('iframe');current=frame;
   frame.title='eBay listings for '+root.dataset.ebayQuery;
   frame.style.cssText='height:220px;width:100%;border:0';
   frame.addEventListener('load',()=>{if(ticket!==generation||!frame.isConnected)return;clearTimeout(timer);status.textContent='Scroll to explore eBay listings. Check each offer on eBay.';},{once:true});
   frame.addEventListener('error',()=>fail(ticket),{once:true});
   timer=setTimeout(()=>fail(ticket),30000);
   frame.src=url.href;wrap.append(frame);rail.replaceChildren(wrap);rail.hidden=false;
  };
  retry.addEventListener('click',()=>{clear();load();});
  root.querySelectorAll('[data-ebay-category]').forEach(button=>button.addEventListener('click',()=>{
   if(button.getAttribute('aria-pressed')==='true'&&current)return;
   clear();root.dataset.ebayQuery=button.dataset.ebayCategory;
   root.querySelectorAll('[data-ebay-category]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
   const link=root.querySelector('.bd-ebay-related__actions a'), url=new URL(link.href);
   url.searchParams.set('_nkw',button.dataset.ebayCategory);link.href=url.href;nearby=true;load();
  }));
  root.querySelector('[data-ebay-preferences]')?.addEventListener('click',()=>{
   Array.from(document.querySelectorAll('a')).find(a=>a.textContent.trim()==='Cookie preferences')?.click();
  });
  document.addEventListener('visitorConsentCollected',load);
  if('IntersectionObserver' in window){
   const observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){nearby=true;observer.disconnect();load();}},{rootMargin:'300px'});observer.observe(root);
  }else nearby=true;
  window.Shopify?.loadFeatures?.([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)load();});
  load();
 });
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
 document.addEventListener('shopify:section:load',start);
})();
  } catch(e) { console.error(e); }
})();

})();
